import { SchedulerData } from 'flagstone-scheduler';
export function setSchedularData(workstations, productionOrders, articles, actions, viewType, props) {
    let resources = []
    var i;

    for (i = 0; i < workstations.length; i++) {
        resources.push({ id: workstations[i].id, name: workstations[i].id })
    }

    let events = []
    var y;
    for (y = 0; y < productionOrders.length; y++) {
        let bgColor = "";
        var imgSrc = "";
        let opacity = "0.7"
        if (productionOrders[y].salesorder) {
            opacity = "1"
        }
        switch (productionOrders[y].state) {
            case "running":
                bgColor = "rgb(92,201,88," + opacity + ")"
                imgSrc = "./img/play_white.svg"
                break;
            case "paused":
                bgColor = "rgb(245,145,40," + opacity + ")"
                imgSrc = "./img/pause_white.svg"
                break;
            case "stopped":
                bgColor = "rgb(216,73,73," + opacity + ")"
                imgSrc = "./img/stop_white.svg"
                break;
            case "cancelled":
                bgColor = "rgb(141,141,141," + opacity + ")"
                imgSrc = "./img/cancel_white.svg"
                break;
            case "planned":
                bgColor = "rgb(141,141,141," + opacity + ")"
                break;
            case "done":
                bgColor = "rgb(92,201,88," + opacity + ")"
                imgSrc = "./img/done_white.svg"
                break;
            default:
        }

        let articlePieces = '';
        if (articles.find(x => x.id === productionOrders[y].article)) {
            articlePieces = articles.find(x => x.id === productionOrders[y].article).name + " x " + productionOrders[y].pieces
        }
        else {
            articlePieces = "NEW ORDER"
        }

        events.push({ id: productionOrders[y].id, start: productionOrders[y].start, end: productionOrders[y].end, resourceId: productionOrders[y].workstation, title: articlePieces, bgColor: bgColor, image: imgSrc, state: productionOrders[y].state.toUpperCase() })
    }

    const data = { resources: resources, events: events }

    if (JSON.stringify(data) !== JSON.stringify(props.planning.data)) {
        actions.setPlanningData(data)
    }

    let schedularData = new SchedulerData(props.planning.date, viewType);
    schedularData.localeMoment.locale('en');
    schedularData.setResources(resources);
    schedularData.setEvents(events);
    schedularData.setRestrictions(props.workstation.restrictions)
    schedularData.setWorkingHours(props.workstation.workingHours)

    return schedularData
}


// var DemoData = {
//     resources: [{
//         id: 'r1',
//         name: 'Resource1'
//     }, {
//         id: 'r2',
//         name: 'Resource2'
//     }, {
//         id: 'r3',
//         name: 'Resource3'
//     }, {
//         id: 'r4',
//         name: 'Resource4'
//     }, {
//         id: 'r5',
//         name: 'Resource5'
//     }, {
//         id: 'r6',
//         name: 'Resource6'
//     }, {
//         id: 'r7',
//         name: 'Resource7Resource7Resource7Resource7Resource7'
//     }],
//     events: [{
//         id: 1,
//         start: '2017-12-18 09:30:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r1',
//         title: 'I am finished',
//         bgColor: '#D9D9D9',
//         showPopover: false
//     }, {
//         id: 2,
//         start: '2017-12-18 12:30:00',
//         end: '2017-12-26 23:30:00',
//         resourceId: 'r2',
//         title: 'I am not resizable',
//         resizable: false
//     }, {
//         id: 3,
//         start: '2017-12-19 12:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r3',
//         title: 'I am not movable',
//         movable: false
//     }, {
//         id: 4,
//         start: '2017-12-19 14:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r4',
//         title: 'I am not start-resizable',
//         startResizable: false
//     }, {
//         id: 5,
//         start: '2017-12-19 15:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r5',
//         title: 'I am not end-resizable',
//         endResizable: false
//     }, {
//         id: 6,
//         start: '2017-12-19 15:35:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r6',
//         title: 'I am normal'
//     }, {
//         id: 7,
//         start: '2017-12-19 15:40:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r7',
//         title: 'I am exceptional',
//         bgColor: '#FA9E95'
//     }, {
//         id: 8,
//         start: '2017-12-19 15:50:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r1',
//         title: 'I am locked',
//         movable: false,
//         resizable: false,
//         bgColor: 'red'
//     }, {
//         id: 9,
//         start: '2017-12-19 16:30:00',
//         end: '2017-12-27 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 1'
//     }, {
//         id: 10,
//         start: '2017-12-19 17:30:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has recurring tasks every week on Tuesday, Friday',
//         rrule: 'FREQ=WEEKLY;DTSTART=20171219T013000Z;BYDAY=TU,FR',
//         bgColor: '#f759ab'
//     }, {
//         id: 11,
//         start: '2017-12-19 18:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 3'
//     }, {
//         id: 12,
//         start: '2017-12-20 18:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 4'
//     }, {
//         id: 13,
//         start: '2017-12-21 18:30:00',
//         end: '2017-12-24 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 5'
//     }, {
//         id: 14,
//         start: '2017-12-23 18:30:00',
//         end: '2017-12-27 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 6'
//     }],
//     eventsForTaskView: [{
//         id: 1,
//         start: '2017-12-18 09:30:00',
//         end: '2017-12-18 23:30:00',
//         resourceId: 'r1',
//         title: 'I am finished',
//         bgColor: '#D9D9D9',
//         groupId: 1,
//         groupName: 'Task1'
//     }, {
//         id: 2,
//         start: '2017-12-18 12:30:00',
//         end: '2017-12-26 23:30:00',
//         resourceId: 'r2',
//         title: 'I am not resizable',
//         resizable: false,
//         groupId: 2,
//         groupName: 'Task2'
//     }, {
//         id: 3,
//         start: '2017-12-19 12:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r3',
//         title: 'I am not movable',
//         movable: false,
//         groupId: 3,
//         groupName: 'Task3'
//     }, {
//         id: 7,
//         start: '2017-12-19 15:40:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r7',
//         title: 'I am exceptional',
//         bgColor: '#FA9E95',
//         groupId: 4,
//         groupName: 'Task4'
//     }, {
//         id: 4,
//         start: '2017-12-20 14:30:00',
//         end: '2017-12-21 23:30:00',
//         resourceId: 'r4',
//         title: 'I am not start-resizable',
//         startResizable: false,
//         groupId: 1,
//         groupName: 'Task1'
//     }, {
//         id: 5,
//         start: '2017-12-21 15:30:00',
//         end: '2017-12-22 23:30:00',
//         resourceId: 'r5',
//         title: 'I am not end-resizable',
//         endResizable: false,
//         groupId: 3,
//         groupName: 'Task3'
//     }, {
//         id: 9,
//         start: '2017-12-21 16:30:00',
//         end: '2017-12-21 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks',
//         groupId: 4,
//         groupName: 'Task4'
//     }, {
//         id: 6,
//         start: '2017-12-22 15:35:00',
//         end: '2017-12-23 23:30:00',
//         resourceId: 'r6',
//         title: 'I am normal',
//         groupId: 1,
//         groupName: 'Task1'
//     }, {
//         id: 8,
//         start: '2017-12-25 15:50:00',
//         end: '2017-12-26 23:30:00',
//         resourceId: 'r1',
//         title: 'I am locked',
//         movable: false,
//         resizable: false,
//         bgColor: 'red',
//         groupId: 1,
//         groupName: 'Task1'
//     }, {
//         id: 10,
//         start: '2017-12-26 18:30:00',
//         end: '2017-12-26 23:30:00',
//         resourceId: 'r2',
//         title: 'R2 has many tasks',
//         groupId: 4,
//         groupName: 'Task4'
//     }, {
//         id: 11,
//         start: '2017-12-27 18:30:00',
//         end: '2017-12-27 23:30:00',
//         resourceId: 'r14',
//         title: 'R4 has many tasks',
//         groupId: 4,
//         groupName: 'Task4'
//     }, {
//         id: 12,
//         start: '2017-12-28 18:30:00',
//         end: '2017-12-28 23:30:00',
//         resourceId: 'r6',
//         title: 'R6 has many tasks',
//         groupId: 3,
//         groupName: 'Task3'
//     }],
//     eventsForCustomEventStyle: [{
//         id: 1,
//         start: '2017-12-18 09:30:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r1',
//         title: 'I am finished',
//         bgColor: '#D9D9D9',
//         type: 1
//     }, {
//         id: 2,
//         start: '2017-12-18 12:30:00',
//         end: '2017-12-26 23:30:00',
//         resourceId: 'r2',
//         title: 'I am not resizable',
//         resizable: false,
//         type: 2
//     }, {
//         id: 3,
//         start: '2017-12-19 12:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r3',
//         title: 'I am not movable',
//         movable: false,
//         type: 3
//     }, {
//         id: 4,
//         start: '2017-12-19 14:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r4',
//         title: 'I am not start-resizable',
//         startResizable: false,
//         type: 1
//     }, {
//         id: 5,
//         start: '2017-12-19 15:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r5',
//         title: 'I am not end-resizable',
//         endResizable: false,
//         type: 2
//     }, {
//         id: 6,
//         start: '2017-12-19 15:35:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r6',
//         title: 'I am normal',
//         type: 3
//     }, {
//         id: 7,
//         start: '2017-12-19 15:40:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r7',
//         title: 'I am exceptional',
//         bgColor: '#FA9E95',
//         type: 1
//     }, {
//         id: 8,
//         start: '2017-12-19 15:50:00',
//         end: '2017-12-19 23:30:00',
//         resourceId: 'r1',
//         title: 'I am locked',
//         movable: false,
//         resizable: false,
//         bgColor: 'red',
//         type: 2
//     }, {
//         id: 9,
//         start: '2017-12-19 16:30:00',
//         end: '2017-12-27 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 1',
//         type: 3
//     }, {
//         id: 10,
//         start: '2017-12-20 18:30:00',
//         end: '2017-12-20 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 2',
//         type: 1
//     }, {
//         id: 11,
//         start: '2017-12-21 18:30:00',
//         end: '2017-12-22 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 3',
//         type: 2
//     }, {
//         id: 12,
//         start: '2017-12-23 18:30:00',
//         end: '2017-12-27 23:30:00',
//         resourceId: 'r1',
//         title: 'R1 has many tasks 4',
//         type: 3
//     }]
// };